import {
  FlueBurnMetricAggregateTimeUnit,
  flueBurnMetricAggregateTimeUnits,
} from "./FlueBurnMetricAggregateTimeUnit";
import { FlueId } from "../FlueId";
import { DateTime, DateTimeUnit } from "luxon";

export class FlueBurnMetricAggregateKeyFactory {
  public static create(
    flueId: FlueId,
    timeUnit: FlueBurnMetricAggregateTimeUnit,
    time?: DateTime
  ): string {
    let luxonTimeUnit: DateTimeUnit = "second";
    if (
      timeUnit === flueBurnMetricAggregateTimeUnits.ever ||
      timeUnit === flueBurnMetricAggregateTimeUnits.atSweep ||
      timeUnit === flueBurnMetricAggregateTimeUnits.sinceSweep ||
      timeUnit === flueBurnMetricAggregateTimeUnits.atSensorOperational
    ) {
      luxonTimeUnit = "second";
    }
    const timeString = time?.toTruncatedIso(luxonTimeUnit) ?? "*";
    return `${flueId}_${timeUnit}_${timeString}`;
  }
}
